<template>
  <a-card class="m-display-flex flex-column nowrap">
    <span slot="title">Create Piutang Lain - Lain</span>
    <a-form class="margin-bottom" :form="form">
      <a-row :gutter="12">
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" class="m-page-wrapper">
          <a-form-item label="Date">
            <a-date-picker
              placeholder="Select Date"
              disabled
              :format="getDefaultDateFormat"
              v-decorator="[
                'date',
                {
                  rules: [{ required: true }],
                  initialValue: initialData.create_dt,
                },
              ]"
            />
          </a-form-item>
          <!-- <a-form-item label="Project Name">
            <a-input
              v-decorator="['project_name', { rules: [{ required: true }] }]"
            ></a-input>
          </a-form-item> -->
          <a-form-item label="Value">
            <a-input-number
              v-decorator="['value', { rules: [{ required: true }] }]"
              :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :min="0.1"
              class="m-width-full m-text-align right"
            ></a-input-number>
          </a-form-item>
          <a-form-item label="Debitur">
            <a-input
              v-decorator="['customer', { rules: [{ required: true }] }]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" class="m-page-wrapper">
          <a-form-item label="Contract No">
            <a-input
              v-decorator="['contract_no', { rules: [{ required: false }] }]"
            ></a-input>
          </a-form-item>
          <a-form-item label="Description">
            <a-input
              v-decorator="['description', { rules: [{ required: true }] }]"
            ></a-input>
          </a-form-item>
          <a-form-item label="Upload File Support">
            <a-upload
              :showUploadList="true"
              :fileList="push"
              :beforeUpload="beforeUpload"
              :remove="handleRemove"
              v-decorator="['upload', { rules: [{ required: false }], valuePropName: 'push' }]"
            >
              <a-button> <a-icon type="upload" />&nbsp;Select File </a-button>
            </a-upload>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button class="padding-remove" type="primary" @click="save"
            >save</a-button
          >
      </div>
    </template>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";

export default {
  name: "CreateARGeneral",
  props: ["id", "type"],
  mixins: [CurrencyFormat],
  components: {
  },
  data() {
    return {
      postData: new FormData(),
      push: [],
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getStandartFormatDate","getDefaultDateFormat",]),
    initialData() {
      return {
        create_dt: moment(),
      }
    }
  },
  created() {
  },
  methods: {
    moment,
    setSubmitForm() {
      this.form.validateFields((err,values) => {
        this.postData = new FormData();
        this.postData.append(
          "date",
          moment(values.date).format(
            this.getStandartFormatDate
          )
        );
        // this.postData.append(
        //   "project_name",
        //   values.project_name
        // );
        this.postData.append(
          "value",
          values.value
        );
        this.postData.append("customer", values.customer);
        this.postData.append(
          "description",
          values.description
        );
        this.postData.append(
          "contract_no",
          values.contract_no ? values.contract_no : ''
        );
        this.postData.append(
          "description",
          values.description
        );
        this.postData.append("upload_file_support", this.push[0]);

        this.postData.append(
          "tlc",
          this.getAuth.username
        );
      });
    },
    submit() {
      this.form.validateFields((err) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
      
        this.btnLoading = true;
        this.setSubmitForm();

        axios({
          method: "post",
          url: this.$serviceUrl + "account_receivable/create_ar_general",
          processData: false,
          data: this.postData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
        .then((response) => {
            this.displayMessage("success-save");
          this.btnLoading = false;
          this.$router.push({ name: "account-receive-index" });
        })
        .catch((err) => {
          let response = Object.assign({}, err.response);
          if (response.data.status == false && response.data.message) {
            this.displayMessageValue("error-other", response.data.message);
          } else {
            let responses = Object.assign({}, err.response.data);
            //console.log(responses);
            this.displayMessageValue("error", responses);
          }
          this.btnLoading = false;
        });
      });
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
        if (FileSize > 2) {
          this.displayMessage("large-file-2mb");
        } else {
          this.push = [file];
          return false;
        }
    },
    handleRemove() {
      this.push = [];
    },
    save(){
      this.confirmMessage("confirm-save");
    },
  },
  mounted() {
    Event.$on("confirmMessageReturn", this.submit);
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.submit);
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
};
</script>

<style>
</style>